import { render, staticRenderFns } from "./updateDescribe.vue?vue&type=template&id=18b7e6f6&"
import script from "./updateDescribe.vue?vue&type=script&lang=js&"
export * from "./updateDescribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports